import { useTranslation } from 'react-i18next';

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business バグ評価詳細セクションで「現在表示中のテキストは翻訳済み」であることを示すバッジ。
 * @graph-connects none
 */
export function TranslatedBadge() {
  const { t } = useTranslation();
  return (
    <span className="ml-2 inline-flex items-center rounded-full border border-[var(--color-border)] bg-[var(--color-bg-elevated)] px-2 py-0.5 text-xs font-medium text-[var(--color-accent-primary)]">
      {t('bugEvaluation.translated', 'Translated')}
    </span>
  );
}
